import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { RequestService } from '../service/request.service';
import { GetterService } from '../service/getter-service.service';
import { ApiService } from '../service/api.service';
import { AuthRedirectService } from '../auth/auth-redirect.service';
import { pageOf } from '../brand/brand-context';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private _local: GetterService,
    private _requestService: RequestService,
    private _router: Router,
    private apiService: ApiService,
    private authRedirectService: AuthRedirectService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const training = route.queryParamMap.get('training') === 'true';
    const orderId = this._local.getSessionItem('orderId');

    if (!orderId || orderId === 'null' || orderId === 'undefined') {
      const queryOrderId = route.queryParamMap.get('orderId');
      if (queryOrderId) {
        this._local.setSessionItem('orderId', queryOrderId);
      }
    }

    if (this._requestService.isLoggedIn()) {
      return true;
    }

    this.authRedirectService.capture(state.url);

    if (this._local.getSessionItem('access_token')) {
      // the guest twin of the checkout being opened
      const routePath =
        pageOf(state.url) === 'new-checkout' ? 'new-guest-checkout' : 'guest';

      this._router.navigate(
        [this._requestService.setUrl(routePath)],
        training ? { queryParams: { training: true } } : undefined
      );
      return false;
    }

    this._router.navigate(
      [this._requestService.setUrl('login')],
      training ? { queryParams: { training: true } } : undefined
    );

    return false;
  }
}

